export default function About() {
    return (
        <div id="about">
            <h2>About the W.O.T.D app</h2>
            <p>W.O.T.D is an app for generating Word Of The Day.
                Word Of The Day is a great way to improve your vocabulary. You can click on the Word Of The Day to get a dictionary definition.</p>
        </div>
    )
}